import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";

export type AppActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
};

export const AppActivitySection = (props: AppActivitySectionProps): ReactElement => {
	const { formHandler } = props;

	return (
		<NotificationSection
			title={localize("_Apps")}
			trackingId="apps"
		>
			<NotificationSection.ItemList>
				<NotificationSection.Item
					label={localize("_NewAvailableApps")}
					subtext={localize("_NewAvailableAppsActivityDescription")}
					attachable={formHandler.for("newAvailableApps")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>

				<NotificationSection.Item
					label={localize("_PlannedMaintenances")}
					subtext={localize("_PlannedMaintenanceActivityDescription")}
					attachable={formHandler.for("maintenances")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>

				<NotificationSection.Item
					label={localize("_UserRequests")}
					subtext={localize("_UserRequestsActivityDescription")}
					attachable={formHandler.for("userRequests")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

AppActivitySection.displayName = "AppActivitySection";
